// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.register_auth-card__MLuud {
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 28px;
  padding: 24px 22px 22px;
  box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);
  width: 100%;
  max-width: 420px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.register_auth-card__form__ZUJmV {
  width: 100%;
}
.register_auth-card__case__ZZRrs {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.14);
  border: 1px solid rgba(130, 177, 148, 0.24);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5E806C;
}
.register_auth-card__title__qm\\+Xr {
  margin: 14px 0 6px;
  font-size: 28px;
  line-height: 1.02;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: #13231D;
}
.register_auth-card__intro__A9CwM {
  margin: 0 0 18px;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  line-height: 1.55;
}
.register_auth-card__tabs__5B5c9 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid rgba(16, 25, 21, 0.12);
  margin-bottom: 20px;
}
.register_auth-card__tab__0QzOi {
  padding: 12px 0 13px;
  text-align: center;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  text-decoration: none;
}
.register_auth-card__tab--active__72e6e {
  color: #3D4642;
  font-weight: 700;
  border-bottom: 2px solid #82B194;
  margin-bottom: -1px;
}
.register_auth-card__fields__z\\+z37 {
  display: grid;
  gap: 12px;
}
.register_auth-card__field-group__mgNob {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;
}
.register_auth-card__field-group__mgNob .MuiInputBase-root {
  width: 100%;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.46);
}
.register_auth-card__field-group__mgNob .MuiInputBase-root::before, .register_auth-card__field-group__mgNob .MuiInputBase-root::after {
  display: none;
}
.register_auth-card__field-group__mgNob .MuiInputBase-root .MuiInputBase-input::placeholder {
  color: rgba(19, 35, 29, 0.46);
  opacity: 1;
}
.register_auth-card__field-group__mgNob:focus-within {
  border-color: rgba(130, 177, 148, 0.48);
  background: rgba(130, 177, 148, 0.14);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.1);
}
.register_auth-card__field-group__mgNob:focus-within .MuiInputBase-input {
  color: #26312D;
}
.register_auth-card__field-group--filled__Qic\\+V .MuiInputBase-input {
  color: #26312D;
}
.register_auth-card__field-group--error__d9zq- {
  border-color: rgba(201, 92, 92, 0.72) !important;
  box-shadow: 0 0 0 4px rgba(201, 92, 92, 0.12) !important;
  background: rgba(201, 92, 92, 0.02);
}
.register_auth-card__switch-field__3l8\\+L {
  min-height: 42px;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 14px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  color: #3D4642;
  cursor: pointer;
  gap: 10px;
}
.register_auth-card__switch__UBM7z {
  width: 24px;
  height: 14px;
  border-radius: 999px;
  background: #DDE2E0;
  position: relative;
  flex: 0 0 24px;
  transition: background 0.2s ease;
}
.register_auth-card__switch__UBM7z::after {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.2s ease;
}
.register_auth-card__switch--active__nO0A4 {
  background: #82B194;
}
.register_auth-card__switch--active__nO0A4::after {
  transform: translateX(10px);
}
.register_auth-card__checks__W4Jb6 {
  display: grid;
  gap: 14px;
  margin-top: 18px;
}
.register_auth-card__check__I2ut2 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 11px;
  line-height: 1.45;
  color: rgba(19, 35, 29, 0.46);
  cursor: pointer;
}
.register_auth-card__check__I2ut2 input {
  display: none;
}
.register_auth-card__check__I2ut2 input:checked + .register_auth-card__box__gM9io {
  background-color: #82B194;
  border-color: #82B194;
}
.register_auth-card__check__I2ut2 input:checked + .register_auth-card__box__gM9io::after {
  content: "✓";
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
}
.register_auth-card__check__I2ut2 a {
  color: #739F84;
}
.register_auth-card__check--error__SfFhi .register_auth-card__box__gM9io {
  border-color: #C95C5C !important;
  background: rgba(201, 92, 92, 0.05);
}
.register_auth-card__check--error__SfFhi span {
  color: rgba(201, 92, 92, 0.8);
}
.register_auth-card__box__gM9io {
  width: 13px;
  height: 13px;
  border: 1px solid rgba(16, 25, 21, 0.18);
  background: #F6F7F5;
  flex: 0 0 13px;
  margin-top: 1px;
}
.register_auth-card__btn-primary__45dhM {
  margin-top: 22px;
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  background: #82B194;
  color: #fff;
  border: none;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s ease;
}
.register_auth-card__btn-primary__45dhM:hover {
  background: #739F84;
}
.register_auth-card__divider__oSF3v {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 16px;
  color: #9AA39F;
  font-size: 11px;
}
.register_auth-card__divider__oSF3v::before, .register_auth-card__divider__oSF3v::after {
  content: "";
  height: 1px;
  background: rgba(16, 25, 21, 0.12);
  flex: 1 1;
}
.register_auth-card__btn-google__IQ88g {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 42px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.12);
  background: #F7F5F1;
  font-weight: 600;
  color: #13231D;
  cursor: pointer;
  font-family: inherit;
}
.register_auth-card__gmark__Al6tu {
  font-weight: 900;
  font-size: 18px;
  color: #4285F4;
}
.register_auth-card__link-home__yjldg {
  display: flex;
  justify-content: center;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #739F84;
  text-decoration: none;
}
.register_auth-card__legal-note__tX0v2 {
  margin: 18px 0 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.55;
  color: rgba(19, 35, 29, 0.46);
}
.register_auth-card__legal-note__tX0v2 a {
  color: #739F84;
  text-decoration: none;
}
.register_auth-card__eye__e9lmu {
  color: rgba(19, 35, 29, 0.46) !important;
}
@media (max-width: 480px) {
  .register_auth-card__MLuud {
    padding: 20px 16px 18px;
    border-radius: 24px;
  }
  .register_auth-card__title__qm\\+Xr {
    font-size: 24px;
  }
  .register_auth-card__tabs__5B5c9 {
    margin-bottom: 16px;
  }
  .register_auth-card__tab__0QzOi {
    font-size: 12px;
    padding: 10px 0;
  }
  .register_auth-card__fields__z\\+z37 {
    gap: 10px;
  }
  .register_auth-card__field-group__mgNob, .register_auth-card__switch-field__3l8\\+L {
    min-height: 40px;
    border-radius: 12px;
    font-size: 13px;
  }
  .register_auth-card__btn-primary__45dhM, .register_auth-card__btn-google__IQ88g {
    min-height: 40px;
    border-radius: 12px;
    font-size: 13px;
  }
  .register_auth-card__checks__W4Jb6 {
    gap: 10px;
    margin-top: 14px;
  }
  .register_auth-card__check__I2ut2 {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/register.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACyIhB;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AD5IJ;;AAfA;EACI,mBCgBmB;EDfnB,wCAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,WAAA;EACA,gBAAA;EACA,oFCJQ;ADsBZ;AAhBI;EACI,WAAA;AAkBR;AAfI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAiBR;AAdI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cCbe;AD6BvB;AAbI;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAeR;AAZI;EACI,aAAA;EACA,8BAAA;EACA,+CAAA;EACA,mBAAA;AAcR;AAXI;EACI,oBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;AAaR;AAXQ;EACI,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AAaZ;AATI;EACI,aAAA;EACA,SAAA;AAWR;AARI;EACI,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAAA;AAUR;AARQ;EACI,WAAA;EACA,eAAA;EACA,6BAAA;AAUZ;AATY;EAAsB,aAAA;AAYlC;AATgB;EACI,6BAAA;EACA,UAAA;AAWpB;AANQ;EACI,uCAAA;EACA,qCAAA;EACA,8CAAA;AAQZ;AANY;EACI,cAAA;AAQhB;AAHY;EACI,cAAA;AAKhB;AADQ;EACI,gDAAA;EACA,wDAAA;EACA,mCAAA;AAGZ;AACI;EACI,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;AAAR;AAEQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AAAZ;AAGQ;EACI,mBClJW;ADiJvB;AAEY;EAAW,2BAAA;AACvB;AAGI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AADR;AAII;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AAFR;AAIQ;EAAQ,aAAA;AADhB;AAGQ;EACI,yBCzKW;ED0KX,qBC1KW;ADyKvB;AAEY;EAAW,YAAA;EAAc,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;AAMhH;AAHQ;EAAI,cC7KW;ADmLvB;AAHY;EACI,gCAAA;EACA,mCAAA;AAKhB;AAHY;EAAO,6BAAA;AAMnB;AAFI;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAIR;AADI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBCvMe;EDwMf,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAGR;AADQ;EAAU,mBC7MK;ADiNvB;AADI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAGR;AAFQ;EAAsB,WAAA;EAAa,WAAA;EAAa,kCAAA;EAAoC,SAAA;AAQ5F;AALI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cCzNe;ED0Nf,eAAA;EACA,oBAAA;AAOR;AAJI;EAAW,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AASlD;AAPI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cClPe;EDmPf,qBAAA;AASR;AANI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAQR;AAPQ;EAAI,cC5PW;ED4PkB,qBAAA;AAWzC;AARI;EAAS,wCAAA;AAWb;AATI;EA3QJ;IA4QQ,uBAAA;IACA,mBAAA;EAYN;EAVM;IACI,eAAA;EAYV;EATM;IACI,mBAAA;EAWV;EARM;IACI,eAAA;IACA,eAAA;EAUV;EAPM;IACI,SAAA;EASV;EANM;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;EAQV;EALM;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;EAOV;EAJM;IACI,SAAA;IACA,gBAAA;EAMV;EAHM;IACI,eAAA;EAKV;AACF","sourcesContent":["@import \"../../assets/styles/variables.scss\";\n\n.auth-card {\n    background: $color-surface; \n    border: 1px solid rgba(12, 36, 28, 0.08);\n    border-radius: 28px;\n    padding: 24px 22px 22px;\n    box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);\n    width: 100%;\n    max-width: 420px;\n    font-family: $font-main;\n\n    &__form {\n        width: 100%;\n    }\n\n    &__case {\n        display: inline-flex;\n        align-items: center;\n        min-height: 24px;\n        padding: 0 10px;\n        border-radius: 999px;\n        background: rgba(130, 177, 148, 0.14);\n        border: 1px solid rgba(130, 177, 148, 0.24);\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: .06em;\n        text-transform: uppercase;\n        color: #5E806C;\n    }\n\n    &__title {\n        margin: 14px 0 6px;\n        font-size: 28px;\n        line-height: 1.02;\n        letter-spacing: -0.03em;\n        font-weight: 800;\n        color: $text-main;\n    }\n\n    &__intro {\n        margin: 0 0 18px;\n        color: rgba(19, 35, 29, 0.68);\n        font-size: 13px;\n        line-height: 1.55;\n    }\n\n    &__tabs {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        border-bottom: 1px solid rgba(16, 25, 21, 0.12);\n        margin-bottom: 20px;\n    }\n\n    &__tab {\n        padding: 12px 0 13px;\n        text-align: center;\n        color: rgba(19, 35, 29, 0.68);\n        font-size: 13px;\n        text-decoration: none;\n\n        &--active {\n            color: #3D4642;\n            font-weight: 700;\n            border-bottom: 2px solid $color-primary;\n            margin-bottom: -1px;\n        }\n    }\n\n    &__fields {\n        display: grid;\n        gap: 12px;\n    }\n\n    &__field-group {\n        min-height: 42px;\n        border: 1px solid rgba(12, 36, 28, 0.08);\n        border-radius: 14px;\n        background: #FFFFFF;\n        display: flex;\n        align-items: center;\n        padding: 0 12px;\n        box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;\n\n        :global(.MuiInputBase-root) {\n            width: 100%;\n            font-size: 14px;\n            color: rgba(19, 35, 29, 0.46);\n            &::before, &::after { display: none; }\n\n            :global(.MuiInputBase-input) {\n                &::placeholder {\n                    color: rgba(19, 35, 29, 0.46);\n                    opacity: 1;\n                }\n            }\n        }\n\n        &:focus-within {\n            border-color: rgba(130, 177, 148, .48);\n            background: rgba(130, 177, 148, .14);\n            box-shadow: 0 0 0 3px rgba(130, 177, 148, .10);\n            \n            :global(.MuiInputBase-input) {\n                color: #26312D;\n            }\n        }\n\n        &--filled {\n            :global(.MuiInputBase-input) {\n                color: #26312D;\n            }\n        }\n\n        &--error {\n            border-color: rgba(201, 92, 92, .72) !important;\n            box-shadow: 0 0 0 4px rgba(201, 92, 92, .12) !important;\n            background: rgba(201, 92, 92, 0.02);\n        }\n    }\n\n    &__switch-field {\n        min-height: 42px;\n        border: 1px solid rgba(12, 36, 28, 0.08);\n        border-radius: 14px;\n        background: #FFFFFF;\n        display: flex;\n        align-items: center;\n        padding: 0 12px;\n        font-size: 14px;\n        color: #3D4642;\n        cursor: pointer;\n        gap: 10px;\n    }\n\n    &__switch {\n        width: 24px;\n        height: 14px;\n        border-radius: 999px;\n        background: #DDE2E0;\n        position: relative;\n        flex: 0 0 24px;\n        transition: background 0.2s ease;\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            left: 2px;\n            top: 2px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            background: #fff;\n            transition: transform 0.2s ease;\n        }\n\n        &--active {\n            background: $color-primary;\n            &::after { transform: translateX(10px); }\n        }\n    }\n\n    &__checks {\n        display: grid;\n        gap: 14px;\n        margin-top: 18px;\n    }\n\n    &__check {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        font-size: 11px;\n        line-height: 1.45;\n        color: rgba(19, 35, 29, 0.46);\n        cursor: pointer;\n\n        input { display: none; }\n\n        input:checked + .auth-card__box {\n            background-color: $color-primary;\n            border-color: $color-primary;\n            &::after { content: \"✓\"; color: white; display: flex; align-items: center; justify-content: center; font-size: 9px; }\n        }\n\n        a { color: $color-primary-hover;  }\n\n        &--error {\n            .auth-card__box {\n                border-color: $color-error !important;\n                background: rgba(201, 92, 92, 0.05);\n            }\n            span { color: rgba(201, 92, 92, .8); }\n        }\n    }\n\n    &__box {\n        width: 13px;\n        height: 13px;\n        border: 1px solid rgba(16, 25, 21, 0.18);\n        background: #F6F7F5;\n        flex: 0 0 13px;\n        margin-top: 1px;\n    }\n\n    &__btn-primary {\n        margin-top: 22px;\n        width: 100%;\n        min-height: 44px;\n        border-radius: 14px;\n        background: $color-primary;\n        color: #fff;\n        border: none;\n        font-weight: 800;\n        cursor: pointer;\n        transition: background 0.2s ease;\n\n        &:hover { background: $color-primary-hover; }\n    }\n\n    &__divider {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin: 18px 0 16px;\n        color: #9AA39F;\n        font-size: 11px;\n        &::before, &::after { content: \"\"; height: 1px; background: rgba(16, 25, 21, 0.12); flex: 1; }\n    }\n\n    &__btn-google {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        min-height: 42px;\n        border-radius: 14px;\n        border: 1px solid rgba(16, 25, 21, 0.12);\n        background: #F7F5F1;\n        font-weight: 600;\n        color: $text-main;\n        cursor: pointer;\n        font-family: inherit;\n    }\n\n    &__gmark { font-weight: 900; font-size: 18px; color: #4285F4; }\n\n    &__link-home {\n        display: flex;\n        justify-content: center;\n        margin-top: 4px;\n        font-size: 12px;\n        font-weight: 700;\n        color: $color-primary-hover;\n        text-decoration: none;\n    }\n\n    &__legal-note {\n        margin: 18px 0 0;\n        text-align: center;\n        font-size: 11px;\n        line-height: 1.55;\n        color: rgba(19, 35, 29, 0.46);\n        a { color: $color-primary-hover; text-decoration: none; }\n    }\n\n    &__eye { color: rgba(19, 35, 29, 0.46) !important; }\n\n    @media (max-width: 480px) {\n        padding: 20px 16px 18px;\n        border-radius: 24px;\n\n        &__title {\n            font-size: 24px;\n        }\n\n        &__tabs {\n            margin-bottom: 16px;\n        }\n\n        &__tab {\n            font-size: 12px;\n            padding: 10px 0;\n        }\n\n        &__fields {\n            gap: 10px;\n        }\n\n        &__field-group, &__switch-field {\n            min-height: 40px;\n            border-radius: 12px;\n            font-size: 13px;\n        }\n\n        &__btn-primary, &__btn-google {\n            min-height: 40px;\n            border-radius: 12px;\n            font-size: 13px;\n        }\n\n        &__checks {\n            gap: 10px;\n            margin-top: 14px;\n        }\n\n        &__check {\n            font-size: 10px;\n        }\n    }\n}","\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves."],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth-card": `register_auth-card__MLuud`,
	"auth-card__form": `register_auth-card__form__ZUJmV`,
	"auth-card__case": `register_auth-card__case__ZZRrs`,
	"auth-card__title": `register_auth-card__title__qm+Xr`,
	"auth-card__intro": `register_auth-card__intro__A9CwM`,
	"auth-card__tabs": `register_auth-card__tabs__5B5c9`,
	"auth-card__tab": `register_auth-card__tab__0QzOi`,
	"auth-card__tab--active": `register_auth-card__tab--active__72e6e`,
	"auth-card__fields": `register_auth-card__fields__z+z37`,
	"auth-card__field-group": `register_auth-card__field-group__mgNob`,
	"auth-card__field-group--filled": `register_auth-card__field-group--filled__Qic+V`,
	"auth-card__field-group--error": `register_auth-card__field-group--error__d9zq-`,
	"auth-card__switch-field": `register_auth-card__switch-field__3l8+L`,
	"auth-card__switch": `register_auth-card__switch__UBM7z`,
	"auth-card__switch--active": `register_auth-card__switch--active__nO0A4`,
	"auth-card__checks": `register_auth-card__checks__W4Jb6`,
	"auth-card__check": `register_auth-card__check__I2ut2`,
	"auth-card__box": `register_auth-card__box__gM9io`,
	"auth-card__check--error": `register_auth-card__check--error__SfFhi`,
	"auth-card__btn-primary": `register_auth-card__btn-primary__45dhM`,
	"auth-card__divider": `register_auth-card__divider__oSF3v`,
	"auth-card__btn-google": `register_auth-card__btn-google__IQ88g`,
	"auth-card__gmark": `register_auth-card__gmark__Al6tu`,
	"auth-card__link-home": `register_auth-card__link-home__yjldg`,
	"auth-card__legal-note": `register_auth-card__legal-note__tX0v2`,
	"auth-card__eye": `register_auth-card__eye__e9lmu`
};
export default ___CSS_LOADER_EXPORT___;
